import RouteNameEnum from '@/router/RouteNameEnum';
import { FunnelStep } from '../FunnelStep';
import store from '@/store/BookingStore';
import { BookingFunnelService } from '@/service/BookingFunnelService/BookingFunnelService';
import getQueryParams from '@/utils/getQueryParams'
import { createRequestData } from '@/logic/createRequestParams';
import { Booking, QuoteResponseDTO, StatusV2 } from '../../../../../requests-module/src';
import { startGlobalPollingFlight } from '@/composables/pollingFlightController';
import checkIsPackageFlight from '@/logic/options/checkIsPackageFlight';
import { applySingleCompanyConfigOnOptionsInit } from '@/logic/options/applySingleCompanyConfigOnOptionsInit';

export const optionsStep = new FunnelStep({
    name: RouteNameEnum.OptionsV2,
    dependencies: [],
    init: async () => {
        const queryParams = getQueryParams()

        let response: Booking | { error: string } | null = null

        if (!store.getters.getToken) {

            if (queryParams.origin) {
                if (queryParams.origin === 'STP' || queryParams.prest_id === 'TNE') {
                    return '/train'
                }
                // no bo yet was created redirect to flight
                return '/flight'
            }

            console.log('init(): Initializing Option Page - depending on the package, make an init call to get BO with defaults');
            // no bo - create one from url 
            const requestData = createRequestData(queryParams);
            response = await BookingFunnelService.initBookingOptions(requestData)

            if ('error' in response) {
                throw new Error('Error with api')
            }

            store.commit('setToken', response.boReference)

        } else {
            console.log('init(): Initializing Option Page - if bo exist, just make a refresh call');
            // has bo, make a refresh call with alt options
            response = await BookingFunnelService.refreshBookingOptions()
            if ('error' in response) {
                throw new Error('Error with api')
            }
            if (checkIsPackageFlight(store.getters.getBooking)) {
                startGlobalPollingFlight(store.getters.getBooking.boReference);
            }
            if (response.status == StatusV2.PROCESSING) {
                // proccesing payment go to /payment page
                return '/payment'
            }
            if (response.status == StatusV2.SUCCESS) {
                return '/paid'
            }

        }

        try {
            await applySingleCompanyConfigOnOptionsInit()
        } catch (error) {
            console.error('[optionsStep] failed to apply single-company options config', error)
        }

        return false
    },

    hasToBeLoggedIn: false
});

